import ExcusedAbsenceService from "../ExcusedAbsence/ExcusedAbsence.service";
import TermAttendanceStatusDomainService from "../TermAttendanceStatus/TermAttendanceStatus.service";
import TranscriptCourseStatusDomainService from "../TranscriptCourseStatus/TranscriptCourseStatus.service";
export default class TranscriptCourseDomainService {
    static fromJson(transcriptCourse) {
        var _a;
        return Object.assign(Object.assign({}, transcriptCourse), { attendanceTrendData: transcriptCourse.attendanceTrendData &&
                // @ts-expect-error - TS7006 - Parameter 'trend' implicitly has an 'any' type.
                transcriptCourse.attendanceTrendData.map((trend) => (Object.assign(Object.assign({}, trend), { date: new Date(trend.date) }))), 
            // Filter out null transcript course attendances
            transcriptCourseAttendances: (_a = transcriptCourse.transcriptCourseAttendances) === null || _a === void 0 ? void 0 : _a.filter(
            // @ts-expect-error - TS7006 - Parameter 'tca' implicitly has an 'any' type.
            (tca) => tca), excusedAbsences: (transcriptCourse.excusedAbsences || []).map(ExcusedAbsenceService.fromJson) });
    }
    static isStudentStoppedOrNeverAttended(transcriptCourse) {
        var _a, _b;
        return (((_a = transcriptCourse.termAttendanceStatus) === null || _a === void 0 ? void 0 : _a.id) ===
            TermAttendanceStatusDomainService.STOPPED_ATTENDING_ID ||
            ((_b = transcriptCourse.termAttendanceStatus) === null || _b === void 0 ? void 0 : _b.id) ===
                TermAttendanceStatusDomainService.NEVER_ATTENDED_ID);
    }
    /**
     * A reason why this student is not eligible to be marked with an attendance status.  Returns null if the student is eligible.
     *
     * @param {TranscriptCourse} transcriptCourse - transcript course of a student in a particular course section
     * @returns {boolean} whether attendance can be taken on this student.
     */
    static getStudentNotEligibleToBeMarkedReason(transcriptCourse) {
        if (TranscriptCourseDomainService.isStudentStoppedOrNeverAttended(transcriptCourse)) {
            return "This student is marked as stopped or never attended.  Mark them as Attending to take attendance.";
        }
        if (transcriptCourse.transcriptCourseStatus.id !==
            TranscriptCourseStatusDomainService.RegisteredId) {
            return "This student is not registered for the course.";
        }
        return null;
    }
    /**
     * Whether attendance can be taken on this student.
     *
     * @param {TranscriptCourse} transcriptCourse - transcript course of a student in a particular course section
     * @returns {boolean} whether attendance can be taken on this student.
     */
    static isStudentEligibleToBeMarked(transcriptCourse) {
        return (TranscriptCourseDomainService.getStudentNotEligibleToBeMarkedReason(transcriptCourse) == null);
    }
}
